import { Button, Col, Container, Form } from "react-bootstrap";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import useFilterParams from "../../hooks/useFilterParams";
import PaginateCard from "../../components/PaginateCard";
import CreditTable from "./components/CreditTable";
import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../modules/helper";
import Card from "../../components/ui/div/Card";
import LoadingButton from "../../components/loading/LoadingButton";
import DateFilter from "../../components/filter/DateFilter";
import Swal from "sweetalert2";

function Credit() {
  const { getParam, setParam, getAllParams } = useFilterParams({
    page: 1,
    items: 10,
  });

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["supervisor-credit"],
    queryFn: () =>
      getAuthMethod("/supervisor/v1/getCredits", getAllParams()).then(res => {
        if (res && res.status === 200) {
          return res.data.data;
        }

        Swal.fire({
          title: "دریافت اطلاعات با خطا مواجه شد",
          confirmButtonText: "متوجه شدم",
          icon: "error",
          confirmButtonColor: "red",
        });
        return { count: 0, items: [], credit: 0 };
      }),

    initialData: { count: 0, items: [], credit: 0 },
    refetchOnWindowFocus: false,
  });

  return (
    <MainMenu>
      <Container>
        <h5>اعتبار سرپرستی</h5>

        <form
          onSubmit={e => {
            e.preventDefault();
            setParam("page", 1);
            refetch();
          }}
        >
          <Card className="mt-4 mb-4 d-flex flex-wrap row-gap-3">
            <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
              <Form.Label>تعداد نمایش:</Form.Label>
              <Form.Select
                defaultValue={getParam("items")}
                onChange={e => setParam("items", e.target.value)}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </Form.Select>
            </Col>

            <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
              <Form.Label>شماره سفارش:</Form.Label>
              <Form.Control
                type="number"
                onChange={e => setParam("numberParcel", e.target.value)}
              />
            </Col>

            <div className="d-flex flex-wrap w-100">
              <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
                <DateFilter
                  value={getParam("startDate")}
                  label="از تاریخ:"
                  set={value => setParam("startDate", value)}
                />
              </Col>
              <Col xs={12} sm={6} lg={4} xl={3} xxl={2} className="px-2">
                <DateFilter
                  value={getParam("endDate")}
                  label="تا تاریخ:"
                  set={value => setParam("endDate", value)}
                />
              </Col>
            </div>

            <div className="w-100 px-2">
              {isFetching && (
                <LoadingButton className="btn-primary" title="در حال دریافت" />
              )}
              {!isFetching && <Button type="submit">فیلتر</Button>}
            </div>
          </Card>
        </form>

        <CreditTable
          credit={data.credit}
          data={data.items}
          page={getParam("page")}
          items={getParam("items")}
          isFetching={isFetching}
        />

        <PaginateCard
          count={data.count}
          numberItems={getParam("items")}
          numberPage={getParam("page")}
          onIndexChoose={number => {
            setParam("page", number);
            refetch();
          }}
        />
      </Container>
    </MainMenu>
  );
}

export default Credit;
